import { elapsed } from "../date/date";
import { DocumentUtils } from "../document/document.utils";
import { StringUtils } from "../string.utils";

export const getInitials = (name) => {
    return !name
        ? ""
        : name
              .replace(/[^\w\s]/gi, "")
              .split(" ")
              .map((word, index, arr) =>
                  index == 0 || (arr.length > 1 && index == arr.length - 1)
                      ? word.charAt(0)
                      : ""
              )
              .join("")
              .toUpperCase();
};

export const formatElapsed = (startDate) => {
    const { days } = elapsed(new Date(startDate));

    const years = Math.floor(days / 365);

    if (years > 0) return years === 1 ? `${years} ano` : `${years} anos`;
    if (days >= 0)
        return days === 0 ? `Hoje` : days === 1 ? `Ontem` : `${days}  dias`;
};

export const maskChar = (startIndex, key, numberShow, value) => {
    if (!value) return "";

    const charStarted = value.slice(startIndex, value.length);
    const calculatedMask = charStarted.length - numberShow;

    return (
        value.slice(0, startIndex) +
        key.repeat(calculatedMask) +
        charStarted.slice(calculatedMask, value.length)
    );
};
export const CNPJMask = (input) => {
    if (!input) return "";

    const cleanValue = DocumentUtils.clean(input);
    return StringUtils.stringMaskApply(cleanValue, "NN.NNN.NNN/NNNN-00", {});
};

export const CNPJCPFMask = (cnpjCpf) => {
    if (!cnpjCpf || typeof cnpjCpf !== "string") return "";
    const cleaned = DocumentUtils.clean(cnpjCpf);
    if (cleaned.length === 14) {
        return StringUtils.stringMaskApply(
            cleaned,
            "NN.NNN.NNN/NNNN-00",
            {}
        );
    } else if (cleaned.length === 11) {
        return StringUtils.stringMaskApply(cleaned, "000.000.000-00", {});
    } else {
        return cnpjCpf;
    }
};
